import React, {forwardRef} from 'react';
import {PagoDeduccion} from "./PagoDeduccion";
import PropTypes from 'prop-types';

export const ContainerPrint = forwardRef(({datapago, prestaciones}, ref)  => {

    return (
        <div ref={ref}>
            <PagoDeduccion
               datapago={datapago}
              prestaciones ={prestaciones}
            />
        </div>
    );
});


ContainerPrint.prototype = {
    datapago: PropTypes.array,
    prestaciones: PropTypes.array,
}

ContainerPrint.defaultProps = {
    datapago: [],
    prestaciones: [],
}


